export var ToggleStateChangeType;
(function (ToggleStateChangeType) {
    /** full tree collapse */
    ToggleStateChangeType["toggleCollapse"] = "toggle-collapse";
    /** full tree expand */
    ToggleStateChangeType["fullExpand"] = "full-expand";
    /** item toggle collapse */
    ToggleStateChangeType["fullCollapse"] = "full-collapse";
    /** item toggle expand */
    ToggleStateChangeType["toggleExpand"] = "toggle-expand";
})(ToggleStateChangeType || (ToggleStateChangeType = {}));
//# sourceMappingURL=toggleStateChangeType.js.map